import React, { createContext, useContext, useEffect, useState } from 'react';
import { createUserWithEmailAndPassword, signOut, getAuth, signInWithEmailAndPassword, onAuthStateChanged, GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import app from './GetApp';


const Auth = getAuth(app)
export const AuthContext = createContext()
const provider = new GoogleAuthProvider()


const UserContext = ({children}) => {

  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  //createUser-
  const createUser = (email, password) =>{
    setLoading(true)
    return createUserWithEmailAndPassword(Auth, email, password);
  }

  //signInUser-
  const logInUser = (email, password) => {
    setLoading(true)
    return signInWithEmailAndPassword(Auth, email, password);
  }

  //signInUserWithGoogle-
  const logInUserWithGoogle = () =>{
    return signInWithPopup(Auth, provider);
  }

  //signOut-
  const signOutUser = () =>{
    setLoading(true)
    return signOut(Auth);
  }

  useEffect(() =>{
    onAuthStateChanged(Auth, (user) =>{
      setUser(user)
      setLoading(false)
    })
  },[])


  const authInfo = { user, createUser, logInUser, logInUserWithGoogle, signOutUser, loading }

  return (
    <AuthContext.Provider value={authInfo}>
      {children}
    </AuthContext.Provider>
  );
};

export default UserContext;